import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import cmdHelper from "bpmn-js-properties-panel/lib/helper/CmdHelper";
import assign from "lodash/assign";
import flattenDeep from "lodash/flattenDeep";

import callable from "./Callable";

function getCallableType(element) {
  const bo = getBusinessObject(element);

  const boCalledElement = bo.get("calledElement"),
    boCaseRef = bo.get("camunda:caseRef");

  let callActivityType = "";
  if (typeof boCalledElement !== "undefined") {
    callActivityType = "bpmn";
  } else if (typeof boCaseRef !== "undefined") {
    callActivityType = "cmmn";
  }

  return callActivityType;
}

const DEFAULT_PROPS = {
  calledElement: undefined,
  "camunda:calledElementBinding": "latest",
  "camunda:calledElementVersion": undefined,
  "camunda:calledElementTenantId": undefined,
  "camunda:variableMappingClass": undefined,
  "camunda:variableMappingDelegateExpression": undefined,
  "camunda:caseRef": undefined,
  "camunda:caseBinding": "latest",
  "camunda:caseVersion": undefined,
  "camunda:caseTenantId": undefined,
};

export default function (group, element, bpmnFactory, translate, modeling) {
  if (!is(element, "camunda:CallActivity")) {
    return;
  }

  group.entries.push(
    entryFactory.selectBox(translate, {
      id: "callActivity",
      label: translate("CallActivity Type"),
      selectOptions: [
        { name: "BPMN", value: "bpmn" },
        { name: "CMMN", value: "cmmn" },
      ],
      emptyParameter: true,
      modelProperty: "callActivityType",

      get(element, node) {
        return {
          callActivityType: getCallableType(element),
        };
      },

      set(element, values, node) {
        const type = values.callActivityType;

        const props = assign({}, DEFAULT_PROPS);

        if (type === "bpmn") {
          props.calledElement = "";
        } else if (type === "cmmn") {
          props["camunda:caseRef"] = "";
        }

        return cmdHelper.updateProperties(element, props);
      },
    }),
  );

  group.entries.push(
    callable(
      element,
      bpmnFactory,
      {
        getCallableType,
      },
      translate,
      modeling,
    ),
  );

  group.entries = flattenDeep(group.entries);
}
